import env from '@upgrade/ui-utils/env';
import merge from 'lodash/merge';
import { doRas, createRequestBody } from '@upgrade/ras/tracker';

export const RAS_ENDPOINT = env.GATSBY_PUBLIC_RAS_ENDPOINT || process.env.GATSBY_PUBLIC_RAS_ENDPOINT;

export const trackRasEvent = async event => {
  doRas(RAS_ENDPOINT, event);
};

export const trackPartnerBankDisplayed = async ({ bankShortName, loanId }) => {
  doRas(RAS_ENDPOINT, 'landing_page', loanId, {}, () =>
    merge({}, createRequestBody(), {
      event: 'landing_page',
      utmCode: {
        content: bankShortName,
        source: 'small_business_referral_imp'
      }
    })
  );
};

export const trackPartnerBankClicked = async ({ bankShortName, loanId }) => {
  doRas(RAS_ENDPOINT, 'click', loanId, {}, () =>
    merge({}, createRequestBody(), {
      event: 'click',
      utmCode: {
        content: bankShortName,
        source: 'small_business_referral'
      }
    })
  );
};

export const trackPlEmailSubmitted = async leadUuid => {
  doRas(RAS_ENDPOINT, 'pl_landing_page_email_submitted', null, {}, () =>
    merge({}, createRequestBody(), {
      event: 'pl_landing_page_email_submitted',
      leadUuid
    })
  );
};
